module.exports = __webpack_public_path__ + "img/male-adult-head.e84a6cc6.svg";